import { authActions } from "_store";
import { useDispatch, useSelector } from "react-redux";
import { history } from "_helpers";
import { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import { EditorState, ContentState, convertFromHTML, convertToRaw, convertFromRaw, Modifier, BlockMapBuilder} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export {ReportTemplate}

function ReportTemplate(){
    const { user: authUser } = useSelector((x) => x.auth);

    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());
    const [reportTemplates, setReportTemplates] = useState([]);
    const [templateName, setTemplateName] = useState("");
    const [editorState, setEditorState] = useState(
      () => EditorState.createEmpty(),
    );
    const content = editorState.getCurrentContent();
    const dataToSaveBackend = preserveTabs(convertToRaw(content));
    const markupTemplate =  reportContentAutoCorrect(draftToHtml(
        dataToSaveBackend
    ));
    const [action, setAction] = useState("");
    const [templateId, setTemplateId] = useState();
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [filteredTemplates, setFilteredTemplates] = useState([]);
    const [orderSequence, setOrderSequence] = useState(1);
    const [reportTemplateContent, setReportTemplateContent] = useState("");
    
    const prevEditorState = useRef(editorState);
    const [customStyleMap, setCustomeStyleMap] = useState();

    const styleTokenizers = {
        'font-size': style => {
        const match = style.match(/font-size:\s*(\d+)px/);
        return match ? [`FONT_SIZE_${match[1]}`] : [];
        },
        'font-family': style => {
        const match = style.match(/font-family:\s*([^;]+)/);
        if (!match) return [];
        const cleaned = match[1].trim().replace(/['"]/g, '').replace(/\s+/g, '_');
        return [`FONT_FAMILY_${cleaned}`];
        },
        'color': style => {
        const match = style.match(/color:\s*([^;]+)/);
        return match ? [`COLOR_${match[1].trim().replace(/#/g, '')}`] : [];
        },
        'background-color': style => {
        const match = style.match(/background-color:\s*([^;]+)/);
        return match ? [`BG_COLOR_${match[1].trim().replace(/#/g, '')}`] : [];
        },
        'text-decoration': style => {
        const match = style.match(/text-decoration:\s*([\w\-]+)/);
        return match ? [`TEXT_DECORATION_${match[1].toUpperCase()}`] : [];
        },
        'text-align': style => {
        const match = style.match(/text-align:\s*(left|right|center|justify)/);
        return match ? [`TEXT_ALIGN_${match[1].toUpperCase()}`] : [];
        },
        'margin': style => {
        const match = style.match(/margin:\s*([^;]+)/);
        return match ? [`MARGIN_${match[1].replace(/\s+/g, '_')}`] : [];
        },
        'padding': style => {
        const match = style.match(/padding:\s*([^;]+)/);
        return match ? [`PADDING_${match[1].replace(/\s+/g, '_')}`] : [];
        },
        'border': style => {
        const match = style.match(/border:\s*([^;]+)/);
        return match ? [`BORDER_${match[1].replace(/\s+/g, '_')}`] : [];
        },
        'width': style => {
        const match = style.match(/width:\s*([^;]+)/);
        return match ? [`WIDTH_${match[1]}`] : [];
        },
        'height': style => {
        const match = style.match(/height:\s*([^;]+)/);
        return match ? [`HEIGHT_${match[1]}`] : [];
        },
        'display': style => {
        const match = style.match(/display:\s*(\w+)/);
        return match ? [`DISPLAY_${match[1].toUpperCase()}`] : [];
        },
    };

    function preserveTabs(rawContent) {
        const tabAsSpaces = '\u00A0\u00A0\u00A0\u00A0'; // or use '\t' if you prefer
        rawContent.blocks.forEach(block => {
            block.text = block.text.replace(/\t/g, tabAsSpaces);
            block.text = block.text.replace(/ {4}/g, tabAsSpaces);
        });
        return rawContent;
    }

    const handleTab = (e) => {
        e.preventDefault();

        const selection = editorState.getSelection();
        const contentState = editorState.getCurrentContent();
        const blockKey = selection.getStartKey();
        const block = contentState.getBlockForKey(blockKey);
        const blockText = block.getText();

        const offset = selection.getStartOffset();

        if (e.shiftKey) {
            // Remove up to 4 leading spaces before cursor
            const start = Math.max(0, offset - 4);
            const beforeCursor = blockText.slice(start, offset);
            const spacesToRemove = beforeCursor.match(/ *$/)?.[0].length || 0;

            if (spacesToRemove > 0) {
                const targetRange = selection.merge({
                    anchorOffset: offset - spacesToRemove,
                    focusOffset: offset,
                });

                const newContentState = Modifier.removeRange(contentState, targetRange, 'backward');
                const newEditorState = EditorState.push(editorState, newContentState, 'remove-range');
                setEditorState(newEditorState);
            }
        } else {
            // Insert 4 spaces on Tab
            const newContentState = Modifier.insertText(contentState, selection, '    ');
            const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
            setEditorState(newEditorState);
        }
    };
//    function cleanWordHTML(html) {
//   return html
//     .replace(/<!--[\s\S]*?-->/g, '')
//     .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
//     .replace(/<[^>]+mso-[^>]+>/gi, '')
//     .replace(/class=["']?Mso[^"'>]*["']?/gi, '')
//     .replace(/<o:p>.*?<\/o:p>/gi, '')
//     .replace(/<\/?span[^>]*>/gi, '')
//     .replace(/<\/?font[^>]*>/gi, '')
//     .replace(/<p[^>]*>/gi, '<p>')
//     .trim();
// }

// const handlePastedText = (text, html, editorState, setEditorState) => {
//   if (html) {
//     const { contentBlocks, entityMap } = htmlToDraft(html);
//     const fragment = BlockMapBuilder.createFromArray(contentBlocks);

//     const contentState = editorState.getCurrentContent();
//     const selection = editorState.getSelection();

//     const newContentState = Modifier.replaceWithFragment(contentState, selection, fragment);
//     const newEditorState = EditorState.push(editorState, newContentState, 'insert-fragment');

//     setEditorState(newEditorState);
//     return 'handled';
//   }

//   // Fallback to plain text
//   const formattedText = text.replace(/\r\n|\r|\n/g, '\n');
//   const selection = editorState.getSelection();
//   const contentState = editorState.getCurrentContent();

//   const newContentState = selection.isCollapsed()
//     ? Modifier.insertText(contentState, selection, formattedText)
//     : Modifier.replaceText(contentState, selection, formattedText);

//   const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
//   setEditorState(newEditorState);
//   return 'handled';
// };

// document.addEventListener('copy', (e) => {
//   const selectionState = editorState.getSelection();
//   const contentState = editorState.getCurrentContent();

//   if (!selectionState.isCollapsed()) {
//     const startKey = selectionState.getStartKey();
//     const endKey = selectionState.getEndKey();
//     const blockMap = contentState.getBlockMap();

//     const selectedBlocks = blockMap
//       .skipUntil((_, k) => k === startKey)
//       .takeUntil((_, k) => k === endKey)
//       .concat([[endKey, blockMap.get(endKey)]]);

//     const rawContent = convertToRaw(
//       ContentState.createFromBlockArray(selectedBlocks.toArray())
//     );

//     e.clipboardData.setData('application/x-draftjs', JSON.stringify(rawContent));
//     e.clipboardData.setData('text/plain', contentState.getPlainText(selectionState));
//     e.preventDefault();
//   }
// });

// document.addEventListener('paste', (e) => {
//   const raw = e.clipboardData.getData('application/x-draftjs');
//   if (raw) {
//     const pastedContentState = convertFromRaw(JSON.parse(raw));
//     const fragment = pastedContentState.getBlockMap();

//     const currentContent = editorState.getCurrentContent();
//     const selection = editorState.getSelection();

//     const newContentState = Modifier.replaceWithFragment(
//       currentContent,
//       selection,
//       fragment
//     );

//     const newEditorState = EditorState.push(
//       editorState,
//       newContentState,
//       'insert-fragment'
//     );

//     setEditorState(EditorState.forceSelection(newEditorState, newContentState.getSelectionAfter()));
//     e.preventDefault();
//   }
// });

const handlePastedText = (text, html, editorState) => {
  const raw = window.clipboardData?.getData('application/x-draftjs');
  if (raw) {
    const pastedContentState = convertFromRaw(JSON.parse(raw));
    const fragment = pastedContentState.getBlockMap();

    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    const newContentState = Modifier.replaceWithFragment(
      currentContent,
      selection,
      fragment
    );

    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      'insert-fragment'
    );

    setEditorState(EditorState.forceSelection(newEditorState, newContentState.getSelectionAfter()));
    return 'handled'; // 👈 This prevents Draft.js from doing its own paste
  }

  return 'not-handled';
};

function decodeHTMLEntities(str) {
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
}

function HTMLToEditorState(rawHTML) {
    const parser = new DOMParser();
    const cleanedHTML = rawHTML
        .replace(/^<div>(\s*<p>(?:&nbsp;|\s)*<\/p>\s*)+/i, '')
        .replace(/\r/g, '')         // Remove carriage returns
        //.replace(/\u00A0/g, ' ')    // Replace non-breaking spaces
        .trim();
    const decodedHTML = decodeHTMLEntities(cleanedHTML);
    const doc = parser.parseFromString(`<div>${decodedHTML}</div>`, 'text/html');

    const spans = doc.querySelectorAll('span[style]');
    spans.forEach(span => {
        const style = span.getAttribute('style');
        const tokens = [];

        // const fontSize = style.match(/font-size:\s*(\d+)px/);
        // if (fontSize) tokens.push(`FONT_SIZE_${fontSize[1]}`);

        // const fontFamily = style.match(/font-family:\s*([^;]+)/);
        // if (fontFamily) {
        // const cleaned = fontFamily[1].trim().replace(/['"]/g, '').replace(/\s+/g, '_');
        // tokens.push(`FONT_FAMILY_${cleaned}`);
        // }       
        Object.keys(styleTokenizers).forEach(key => {
            tokens.push(...styleTokenizers[key](style));
        });

        if (tokens.length) span.setAttribute('data-style', tokens.join(' '));
    });

    const paragraphs = doc.querySelectorAll('p');

    paragraphs.forEach(p => {
        const html = p.innerHTML;

        // Match leading &nbsp; sequences
        const match = html.match(/^(&nbsp;)+/);
        if (match) {
            const count = match[0].split('&nbsp;').length - 1;

            // Apply a custom data-style token
            const existing = p.getAttribute('data-style') || '';
            const updated = existing ? `${existing} INDENT_${count}` : `INDENT_${count}`;
            p.setAttribute('data-style', updated);
        }
    });

    const preprocessedHTML = doc.body.innerHTML.replace(/^\s*<p>(?:&nbsp;|\s)*<\/p>\s*/i, '').trim();
    const { contentBlocks, entityMap } = htmlToDraft(preprocessedHTML);
    const filteredBlocks = contentBlocks.filter(block => {
        const text = block.getText().trim();
        return text.length > 0 || block.type !== 'unstyled';
    });
    const contentState = ContentState.createFromBlockArray(filteredBlocks, entityMap);
    const eState = EditorState.createWithContent(contentState);

    const raw = convertToRaw(contentState);
    const styleSet = new Set();
    raw.blocks.forEach(block => {
        block.inlineStyleRanges?.forEach(range => styleSet.add(range.style));
    });

    const CSMap = {};
    styleSet.forEach(style => {
        if (style.startsWith('COLOR_')) {
            const hex = '#' + style.replace('COLOR_', '');
            CSMap[style] = { color: hex };
        }
        if (style.startsWith('BG_COLOR_')) {
            const hex = '#' + style.replace('BG_COLOR_', '');
            CSMap[style] = { backgroundColor: hex };
        }
        if (style.startsWith('TEXT_DECORATION_')) {
            CSMap[style] = { textDecoration: style.split('_')[2].toLowerCase() };
        }
        if (style.startsWith('TEXT_ALIGN_')) {
            CSMap[style] = { textAlign: style.split('_')[2].toLowerCase() };
        }
        if (style.startsWith('MARGIN_')) {
            CSMap[style] = { margin: style.replace('MARGIN_', '').replace(/_/g, ' ') };
        }
        if (style.startsWith('PADDING_')) {
            CSMap[style] = { padding: style.replace('PADDING_', '').replace(/_/g, ' ') };
        }
        if (style.startsWith('BORDER_')) {
            CSMap[style] = { border: style.replace('BORDER_', '').replace(/_/g, ' ') };
        }
        if (style.startsWith('WIDTH_')) {
            CSMap[style] = { width: style.replace('WIDTH_', '') };
        }
        if (style.startsWith('HEIGHT_')) {
            CSMap[style] = { height: style.replace('HEIGHT_', '') };
        }
        if (style.startsWith('DISPLAY_')) {
            CSMap[style] = { display: style.split('_')[1].toLowerCase() };
        }
        if (style.startsWith('INDENT_')) {
            const level = parseInt(style.replace('INDENT_', ''), 10);
            CSMap[style] = { marginLeft: `${level * 8}px` }; // or 16px, depending on your design
        }

    });
    return { eState, CSMap };
}
    // const htmlToSlate = html => {
    //     const doc = parseDocument(html);
    //     const nodes = [];

    //     doc.children.forEach(elem => {
    //         if (elem.name === 'p') {
    //         const children = [];

    //         elem.children?.forEach(child => {
    //             if (child.type === 'text') {
    //             children.push({ text: child.data || '' });
    //             }

    //             if (child.name === 'span') {
    //             const style = child.attribs?.style || '';
    //             const text = child.children?.[0]?.data || '';
    //             const leaf = { text };

    //             // Extract font-size and font-family
    //             const fontSizeMatch = style.match(/font-size:\s?([\w\d.]+)px?/);
    //             if (fontSizeMatch) leaf.fontSize = `${fontSizeMatch[1]}px`;

    //             const fontFamilyMatch = style.match(/font-family:\s?([^;]+);?/);
    //             if (fontFamilyMatch) leaf.fontFamily = fontFamilyMatch[1].trim();

    //             children.push(leaf);
    //             }
    //         });

    //         nodes.push({
    //             type: 'paragraph',
    //             children: children.length ? children : [{ text: '' }],
    //         });
    //         }
    //     });

    //     return nodes.length ? nodes : [{ type: 'paragraph', children: [{ text: '' }] }];
    // };


    // const renderLeaf = ({ attributes, children, leaf }) => {
    //     const style = {};

    //     if (leaf.fontSize) style.fontSize = leaf.fontSize;
    //     if (leaf.fontFamily) style.fontFamily = leaf.fontFamily;
    //     if (leaf.color) style.color = leaf.color;
    //     if (leaf.fontWeight) style.fontWeight = leaf.fontWeight;
    //     // Add more styles if needed

    //     return <span {...attributes} style={style}>{children}</span>;
    // };

    // const initialValue = [
    // {
    //     type: 'paragraph',
    //     children: [{ text: 'abcfd   ' }],
    // },
    // ];

    // const editor = useMemo(() => withReact(createEditor()), []);
    // const [value, setValue] = useState(initialValue);

    if(authUser.user_type !== 'D')
    {
         history.navigate("/home");
    }

    const closeClick = (event) => {
        history.navigate("/home");
    };

    function randomNumberInRange(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    useEffect(()=>{
        repoortTemplateList();
    }, [refreshGrid]);

    function repoortTemplateList(){
        const url = `${process.env.REACT_APP_API_URL}/doctor/getTemplate`;
        const user_key = authUser?.user_key;

        const request_id = randomNumberInRange(1000000, 9000000);
        const userJSON = localStorage.getItem('user');
        let validToken = true;
        if(userJSON===null){
            validToken = false;
        }
        
        if(validToken)
        {
            if(JSON.parse(userJSON)===undefined){
            validToken = false;
            }
        }

        if(validToken)
        {
            if(JSON.parse(userJSON).token===undefined){
            validToken = false;
            }
        }

        if(!validToken){
            alert('Session expired, try to relogin.');
            logout();
            //refreshExpiryToken();
            return false;
        }
        const token = JSON.parse(userJSON).token;

        const config = {
            headers: {
            'content-type': 'application/json',
            //'Access-Control-Allow-Origin': '*',
            //'Access-Control-Allow-Methods': 'POST,PATCH,OPTIONS',
            'Authorization': `Bearer ${token}`,
            'doctor_key': user_key.toString(),
            'request_id': request_id.toString(),
            'template_id': ''          
            },
        };
        try {
            axios.get(url, config).then((response) => {
                let updatedValue = {};
                updatedValue = response.data; 

                if(updatedValue.length > 0){
                    setReportTemplates(updatedValue);
                }
            })
            .catch(error => {
                if(error.response.data.message==='Unauthorized')
                {
                alert('Unauthorized session, try to relogin.');
                logout();
                }
                else{
                alert(error.response.data.message);
                }
            });
        } catch (err) {
          if (err.code === '404') {
            return
          }
        }

    }

    const addEditTemplate = (event, param, template_id, template_name, report_template, order_seq) => {
        const user_key = authUser?.user_key;
        if(param === 'EDIT'){
            setTemplateName(template_name);
            const { eState, CSMap } = HTMLToEditorState(report_template);
            setEditorState(eState);
            setCustomeStyleMap(CSMap);
            
            setAction('EDIT');
            setTemplateId(template_id);
            setOrderSequence(order_seq);
            setReportTemplateContent(report_template);
        }
        else if(param === 'ADD'){   
            setTemplateName("");
            setEditorState(EditorState.createEmpty());
            setAction('ADD');
            setTemplateId(0);
            setOrderSequence(1);
            setReportTemplateContent("");
        }
        else if (param === 'DELETE')
        {
            updateTemplate(template_id, '.', '.', user_key, 1, param);
            return;
        }
        let modal = document.querySelector("#submitTemplate");
        modal.classList.toggle("closed");
    }
 
    const submitTemplate = (event, param) => {   
        const originalTemplate = reportTemplateContent;
        const user_key = authUser?.user_key;

        if(param !== "CLOSE"){
            if(templateName === ''){
                alert('Template Name cannot be blank');
                return false;
            }
            if (param === 'EDIT' && templateName === originalTemplate.template_name &&
                reportContentAutoCorrect(originalTemplate.report_template).replace(/\s+/g, " ").trim() === 
                                markupTemplate.replace(/\s+/g, " ").trim() &&
                templateId === originalTemplate.template_id &&
                orderSequence === originalTemplate.order_seq
            ) {
                alert('No changes to update');
                return false;
            }

            if(reportTemplates.some(template => 
                template.template_id !== templateId  &&
                String(template.template_name).toLowerCase().trim() === templateName.toLowerCase().trim()))
            {
                alert('Duplicate Template Name Found');
                return false;
            }
            if(templateName !== '' && (markupTemplate.trim() === '' || markupTemplate.trim() === '<h2></h2>' || markupTemplate.trim() === '<p></p>')){
                alert('Report Template cannot be blank');
                return false;
            }
            updateTemplate(templateId, templateName, markupTemplate, user_key, orderSequence, param);
        }
        
        let modal = document.querySelector("#submitTemplate");
        modal.classList.toggle("closed");
    }

    const updateTemplate = (template_id,template_name,content,user_key, order_seq, action_tag) =>{
        const url = `${process.env.REACT_APP_API_URL}/doctor/updateTemplate`;
        var responseMessage = '';
        if(user_key===null || user_key===undefined){
            user_key=0;
        }
        if(template_id===null || template_id===undefined){
            template_id=0;
        }
        if(order_seq===null || order_seq==='' || order_seq<1){
            order_seq=1;
        }

        // 👇 Create new FormData object and append files
        const data = new FormData();
        data.append(`template_id`, template_id.toString());
        data.append(`template_name`, template_name.toString());
        data.append(`content`, content.toString());
        data.append(`doctor_key`, user_key.toString());
        data.append(`order_seq`, order_seq.toString());
        data.append(`action_tag`, action_tag.toString());

        const token = JSON.parse(localStorage.getItem('user')).token;
        const config = {
            headers: {
            'content-type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
            },
        };

        try {
            axios.post(url, data, config).then((response) => {
                console.log(response);
                if(response.data.template_id){
                    if(action_tag === 'ADD'){
                        responseMessage = `"${response.data.template_name}" template created successfully`;
                    }
                    else if(action_tag === 'EDIT'){
                        responseMessage = `"${response.data.template_name}" template edited successfully`;
                    }
                    else if(action_tag === 'DELETE'){
                        responseMessage = `"${response.data.template_name}" template deleted successfully`;
                    }
                    setRefreshGrid(prev => !prev);
                    alert(responseMessage);
                }
            })
            .catch(error => {
                var Unauthorized = false; var errorCatch = '';
                if(error.response!= null){
                    errorCatch = 'Exception found!';
                    if(error.response.data != null){
                        if(error.response.data.message==='Unauthorized')
                        {
                            Unauthorized = true;
                        }
                        else
                        {
                            errorCatch = error.response.statusText;
                        }
                    }
                }

                if(Unauthorized)
                {
                    alert('Unauthorized session, try to relogin.');
                    logout();
                }
                else{
                    alert(errorCatch);
                }
                });
            } catch (err) {
                alert(err.code);
                if (err.code === '404') {
                    return
                }
            }
    }

    const handleChange = (event) => {
        if(event.target.id === 'txttemplate_name'){
            setTemplateName(event.target.value );
        }
        else if(event.target.id === 'txtorder_seq'){
            setOrderSequence(event.target.value );
        }
    };

    const handleSearchChange = (event) => {
        var filterColName = event.target.id;
        var filterColValue = String(event.target.value).toLowerCase(); 
        
        if(filterColValue){
            if(filterColName==='template_name'){
                const filteredData = reportTemplates.filter(template =>
                    String(template[filterColName]).toLowerCase().includes(filterColValue)
                );
                setFilteredTemplates(filteredData);
            }
            else{
                const filteredDataNum = reportTemplates.filter(template =>
                    String(template[filterColName]).toLowerCase().match(filterColValue)
                );
                setFilteredTemplates(filteredDataNum);
            }
        }
        else{
            setFilteredTemplates([]);
        }
    }

    function reportContentAutoCorrect(markupReportTemp) {
       markupReportTemp = markupReportTemp.replace(//g, '&#8226;').replace(/Ø/g, '&#8226;').replace(/●/g, '&#8226;').replace(/·/g, '&#8226;'); /*.replace('à', '&rarr;')*/
        
        if(markupReportTemp.indexOf(`\n`) > 0){
          let headerLine = markupReportTemp.slice(0, markupReportTemp.indexOf(`\n`));
          let headerLineTemp = headerLine;
          if(headerLineTemp.indexOf(`<h`) === -1){
            if(headerLineTemp.indexOf(`<p><strong>`) !== -1 
              && headerLineTemp.indexOf(`</strong></p>`) !== -1){
              headerLineTemp = headerLineTemp.replace(`<p><strong>`, `<h2><strong>`);
              headerLineTemp = headerLineTemp.replace(`</strong></p>`, `</strong></h2>`);
            }
          }
          markupReportTemp = markupReportTemp.replace(headerLine, headerLineTemp);
        }

        return markupReportTemp;
    }

    const sortClick = (event, columnName) =>{
        var sortColName = columnName;
        var sortColValue = '';
        if(event.target.className.indexOf("arrow-up")>=0)
        {
            sortColValue = "DESC";
            event.target.classList.remove('bi-arrow-up');
            event.target.classList.add('bi-arrow-down');
        }
        else
        {
            sortColValue = "ASC";

            event.target.classList.remove('bi-arrow-down');
            event.target.classList.add('bi-arrow-up');
        }
        const sortedTemplates = [...reportTemplates].sort((a, b) =>{ 
            const valA = isNaN(a[sortColName])? String(a[sortColName]).toLowerCase() : Number(a[sortColName]);
            const valB = isNaN(b[sortColName])? String(b[sortColName]).toLowerCase() : Number(b[sortColName]);
            const isNumberA = !isNaN(valA);
            const isNumberB = !isNaN(valB);

            if (isNumberA && isNumberB) {
                return sortColValue === "ASC" ? valA - valB : valB - valA;
            } else {
                return sortColValue === "ASC" 
                    ? String(valA).localeCompare(String(valB)) 
                    : String(valB).localeCompare(String(valA));
            }
        });
        setReportTemplates(sortedTemplates);
    }

    return(
        <div className="tele-body">
           <main>
                <div className="container-fluid px-4">
                    <div className="row">
                        <div className="col-12 col-lg-8 col-md-8 col-sm-8 mt-2">
                        <h5 className="text-blue font-roboto font-weight700">
                            <small>Report Templates </small>
                        </h5>
                        </div>
                         <div className="col-6 col-lg-2 col-md-2 col-sm-2 mt-2 mb-1">
                        <button type="button" className="btn btn-secondary btn-sm btn-block text-light bi bi-plus-square" name="Add" onClick={event => addEditTemplate(event, 'ADD', 0, '', '', 0)}> ADD</button>
                        </div>
                        <div className="col-6 col-lg-2 col-md-2 col-sm-2 mt-2 mb-1">
                        <button
                            type="button"
                            className="btn btn-dark btn-sm btn-block text-light bi bi-x-circle"
                            name="Close"
                            onClick={closeClick}
                        >
                            {" "}
                            CLOSE
                        </button>
                        </div>
                    </div>
                
                    <hr className="mt-0" />

                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <div className="card">
                                <div className="card-header bg-gradient-1 text-light">
                                    {/* Table Heading */}
                                    <div className="row">
                                        <div className="col-3 col-sm-1 col-md-1">
                                            <p className="tele-table-heading"><i className="bi bi-arrow-down"  onClick={event => sortClick(event, 'template_id') }></i> Id </p>
                                            <input type="text" className="form-control form-control-sm tele-table-searcharea" id= "template_id" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-5 col-sm-2 col-md-6">
                                            <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'template_name') }></i>Template Name</p>
                                            <input type="text" className="form-control form-control-sm tele-table-searcharea" id="template_name" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-3 col-sm-2 col-md-2">
                                            <p className="tele-table-heading"><i className="bi bi-arrow-down icon-muted" onClick={event => sortClick(event, 'order_seq') }></i>Order Sequence</p>
                                            <input type="text" className="form-control form-control-sm tele-table-searcharea" id="order_seq" onChange={handleSearchChange} placeholder="" />
                                        </div>
                                        <div className="col-sm-2 col-md-2 d-none d-sm-block"><p className="tele-table-heading">Action</p></div>
                                    </div>
                                </div>
                                <div className="card-body tele-table-padding studylist-area">
                                    {/* tele-table-rowbg1 */}
                                    <div className="row studylist" id="divReportTemplate">
                                    </div>
                                    {(filteredTemplates.length > 0 ? filteredTemplates : reportTemplates ).map((data, i) => (
                                        <div key={i} className="row studylist" >
                                            <div className="col-3 col-sm-1 col-md-1"><p className="tele-table-text float-left">{data.template_id}</p></div>
                                            <div className="col-5 col-sm-2 col-md-6"><p className="tele-table-text">{data.template_name}</p></div>
                                            <div className="col-3 col-sm-2 col-md-2"><p className="tele-table-text float-left">{data.order_seq}</p></div>
                                            <div className="col-8 col-sm-2 col-md-2">
                                                <button type="button" className="btn btn-outline-warning btn-sm bi bi-pencil-fill m-1" title="Edit Template" onClick={event => addEditTemplate(event, 'EDIT', data.template_id, data.template_name, data.report_template, data.order_seq)}>
                                                </button>
                                                <button type="button" className="btn btn-outline-danger btn-sm bi bi-trash-fill m-1" title="Delete Template" onClick={event => addEditTemplate(event, 'DELETE', data.template_id, data.template_name, data.report_template, data.order_seq)}>
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    </div>  
                </div>
            </main>

            <div id="submitTemplate" className="modal closed">

                {/*<!--Modal content -->*/}
                <div className="report-modal-content">
                    <div className="modal-header pt-2">
                        <span className="close" onClick={event => submitTemplate(event, 'CLOSE', null, '')}>&times;</span>
                        <h6 className="mb-0"><i className="bi bi-clipboard-check-fill"></i> Report Template: <span id="spnsubmit_template"></span>
                        </h6>
                    </div>
                    <div className="modal-body" style={{paddingBottom:"0rem"}}>
                        <div className="row">
                            <div className="icol-20 col-s-12 reportarea row justify-content-center pb-3" id="reportarea">
                                <div style={{paddingLeft:"0.9rem", textAlign:"right" }}  className="container wrapper">
                                    <div className="page-wrapper">
                                        <div className="row">
                                            <div className="row pe-2 ps-2">
                                                <div className="col-1">
                                                    <div className="mb-2">
                                                        <label htmlFor="">
                                                            <small> Name:</small>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="mb-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Template Name"
                                                            name="template_name"
                                                            id="txttemplate_name"
                                                            aria-describedby=""
                                                            value={templateName}
                                                            maxLength={50}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-2">
                                                    <div className="mb-2">
                                                        <label htmlFor="">
                                                            <small> Order Seq:</small>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-1">
                                                    <div className="mb-2">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Order Sequence"
                                                            name="order_seq"
                                                            id="txtorder_seq"
                                                            aria-describedby=""
                                                            value={orderSequence}
                                                            min={1}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-12">
                                    <div className="form-group" > 
                                        {/*<label for="" className="font-size14">Report Content:</label>*/}
                                        <Editor
                                            editorState={editorState}
                                            onEditorStateChange={setEditorState}
                                            customStyleMap={customStyleMap}
                                            wrapperClassName="wrapper-class"
                                            editorClassName="editor-class"
                                            toolbarClassName="toolbar-class"
                                            handlePastedText={handlePastedText}
                                            spellCheck={true}
                                            onTab={handleTab}
                                        />
                                        {/* <Slate key={JSON.stringify(value)}
                                        editor={editor} 
                                        initialValue={value}>
                                        <Toolbar/>
                                        <Editable 
                                        renderLeaf={renderLeaf}
                                        value={value} 
                                        onChange={newValue => setValue(newValue)} />
                                        </Slate> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer pt-2">
                        <div className="row justify-content-center">
                            <div id="divSubmitReport" className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-send-fill" id="btnSubmitReport" onClick={event => submitTemplate(event, action, null, '')}> SAVE </button></div>
                            <div className="col-lg-3 col-3"><button type="button"
                                className="btn btn-secondary btn-sm btn-block bi bi-x-square" id="btnSubmitReportClose" onClick={event => submitTemplate(event, 'CLOSE', null, '')}> CLOSE </button></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}